import * as z$1 from "zod/v4";
//#region src/schemas/daemon/service-connection-correlation.ts
const SERVICE_CONNECTION_ID_QUERY_PARAMETER = "connectionId";
const serviceConnectionDiagnosticIdSchema = z$1.uuid();
//#endregion
export { SERVICE_CONNECTION_ID_QUERY_PARAMETER, serviceConnectionDiagnosticIdSchema };

//# sourceMappingURL=service-connection-correlation.js.map